export default function EFElectricGrill(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.5589 30.3744H6.44047C5.55639 30.3744 4.83984 29.6053 4.83984 28.6565V3.90199C4.83984 2.95313 5.55639 2.18408 6.44047 2.18408H25.5589C26.443 2.18408 27.1595 2.95313 27.1595 3.90199V28.6565C27.1595 29.6053 26.443 30.3744 25.5589 30.3744Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4.83984 8.66846H27.1595" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.1309 26.3625H8.86396C8.27493 26.3625 7.79688 25.85 7.79688 25.2173V15.4641C7.79688 14.8314 8.27493 14.3188 8.86396 14.3188H23.1309C23.7199 14.3188 24.198 14.8314 24.198 15.4641V25.2173C24.198 25.85 23.7199 26.3625 23.1309 26.3625Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3125 6.24434H19.0315V4.47607H13.3125V6.24434Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.742 5.36074C10.742 5.94195 10.2706 6.41337 9.68935 6.41337C9.10765 6.41337 8.63672 5.94195 8.63672 5.36074C8.63672 4.77952 9.10765 4.30811 9.68935 4.30811C10.2706 4.30811 10.742 4.77952 10.742 5.36074Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.3631 5.36074C23.3631 5.94195 22.8917 6.41337 22.3104 6.41337C21.7287 6.41337 21.2578 5.94195 21.2578 5.36074C21.2578 4.77952 21.7287 4.30811 22.3104 4.30811C22.8917 4.30811 23.3631 4.77952 23.3631 5.36074Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.78125 11.4907H24.1823" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.78906 30.815H9.5156V30.3735H7.78906V30.815Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.4805 30.815H24.207V30.3735H22.4805V30.815Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
